export default "__VITE_PUBLIC_ASSET__8ed6141b__"